const parseAllowedHosts = (): Set<string> => {
  const raw = import.meta.env.VITE_ASSET_PREVIEW_ALLOWED_HOSTS;
  if (typeof raw !== 'string' || raw.trim() === '') {
    return new Set();
  }
  return new Set(
    raw
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean),
  );
};

const allowedPreviewHosts = parseAllowedHosts();

/**
 * Validate preview URLs before rendering user-controlled remote content.
 * - Allows only http/https protocols.
 * - Optionally enforces host allowlist via VITE_ASSET_PREVIEW_ALLOWED_HOSTS.
 */
export const toSafePreviewUrl = (candidate: string | null | undefined): string | null => {
  if (!candidate) {
    return null;
  }
  try {
    const parsed = new URL(candidate);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return null;
    }
    if (allowedPreviewHosts.size > 0 && !allowedPreviewHosts.has(parsed.hostname.toLowerCase())) {
      return null;
    }
    return parsed.toString();
  } catch {
    return null;
  }
};
